module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp2_5010.75816856.png";